export function render(props:any) {
    return function(tok:string, i:number) {
        return (i % 2) ? tok.split(".").reduce((prev:any, current:string) => prev[current], props) : tok;
    };
}

interface Dict {
    [key:string]: object
}